import * as React from 'react'
import { TooltipWrapper } from 'uiComponents/tooltip.new/tooltipWrapper'
import { LucideIcon } from 'utils/lucideIcon'
import { OnSaleFactorLine } from 'capacity/derive/onSale'
import { PRODUCTS } from 'capacity/copy'

export function OnSaleCell({ factors }: { factors: OnSaleFactorLine[] | null }) {
    if (!factors) {
        return (
            <TooltipWrapper
                text={PRODUCTS.onSale.optionTooltip}
                arrowPosition="right"
                className="capacity-tip capacity-on-sale-tip"
                revealOnFocus
            >
                <span className="capacity-on-sale-value muted" tabIndex={0}>
                    {PRODUCTS.onSale.none}
                </span>
            </TooltipWrapper>
        )
    }
    const onSale = factors.every((factor) => factor.met)
    return (
        <TooltipWrapper
            arrowPosition="right"
            className="capacity-tip capacity-on-sale-tip"
            revealOnFocus
            content={
                <ul className="capacity-on-sale-factors">
                    {factors.map((factor) => (
                        <li key={factor.key} className={factor.met ? 'met' : 'not-met'}>
                            <span className="capacity-on-sale-factor-icon" aria-hidden="true">
                                <LucideIcon iconName={factor.met ? 'Check' : 'X'} size={14} strokeWidth={2} />
                            </span>
                            <span className="capacity-on-sale-factor-text">
                                <span>{factor.label}</span>
                                {factor.detail && (
                                    <span className="capacity-on-sale-factor-detail">{factor.detail}</span>
                                )}
                            </span>
                        </li>
                    ))}
                </ul>
            }
        >
            <span className="capacity-on-sale-value" tabIndex={0}>
                {onSale ? PRODUCTS.onSale.yes : PRODUCTS.onSale.no}
            </span>
        </TooltipWrapper>
    )
}
